import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import Editor from '../../../components/board/inquiry/Editor';
import { createInquiry } from '../../../api/boardCommunication.api';
import { useEffect } from 'react';
import useNotification from '../../../hooks/useNotification';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BoardInquiryCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push('/board/inquiry');
    }
  }, [submitRes, submitIsLoading]);

  const onSubmit = (data: FormData) => {
    submitExecute(createInquiry(data));
  };

  return (
    <div className="content scrollbar">
      {submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={submitError} />
      <SimpleHeader
        parentMenu={t('common.menu.board')}
        currentMenu={t('board.inquiry.title4')}
        iconFile="icon-board-big.svg"
      />
      <Editor onSubmit={onSubmit} />
    </div>
  );
};

export default BoardInquiryCreate;
